var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "table-toolbar" }, [
        _c("span", [
          _vm._v(
            _vm._s(_vm.$t("admins.adminsNumber")) +
              " " +
              _vm._s(_vm.adminsDatasource.total) +
              " "
          )
        ]),
        _c(
          "div",
          { staticClass: "table-toolbar__group" },
          [
            _c("TableSearch", {
              attrs: { "data-source": _vm.adminsDatasource }
            }),
            _c("TableLimitSelector", {
              attrs: { "data-source": _vm.adminsDatasource }
            }),
            _c("PrintBtn", { staticClass: "u-margin-left-toolbar" }),
            _c("DownloadBtn", { attrs: { data: _vm.adminsDatasource.docs } }),
            _c("gl-button", {
              directives: [
                {
                  name: "profile-guard",
                  rawName: "v-profile-guard",
                  value: "views.admins.add",
                  expression: "'views.admins.add'"
                }
              ],
              attrs: {
                id: "admin.btn-add",
                "color-primary": "",
                type: "button",
                text: _vm.$t("admins.addAdmin"),
                "icon-left": "glicon-user-thin-plus"
              },
              on: { onClick: _vm.goToCreate }
            })
          ],
          1
        )
      ]),
      _c("Table", {
        attrs: {
          columns: _vm.adminsColumns,
          "data-source": _vm.adminsDatasource
        },
        on: { clickRow: _vm.goToEdit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }